var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gastos"},[_c('gastos-form',{attrs:{"gasto":_vm.gasto,"proyectoId":_vm.id_proyecto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }